// ปีการศึกษาของ cohort ปัจจุบัน (ผู้สมัครรอบนี้) — mirror ของ tcas65-student-api/constants/school-year.js
// 2569 = tcas70 cohort (tcas cycle = school_year + 1). ขึ้น cohort ใหม่: แก้จุดเดียว
// ค่าเป็น string (school_year ใน DB เก็บ string) — จุดที่เทียบเชิงตัวเลขครอบด้วย Number()
export const CURRENT_SCHOOL_YEAR = '2569';

// เทอม GPAX ของ cohort ปีปัจจุบัน (ยังไม่จบ) ตามฤดูกาล — ต้นฤดู '4', ~ต.ค. เกรดเทอม 1 ออก '5', ใกล้จบ '6'
// ใช้เลือกช่อง gpax (gpaxCodeOf) แทนการอ้าง student.school_term รายคน (ค้างผิดจาก GED — เกรดเก็บช่อง gpax6)
// flip ตามรอบ: แก้จุดเดียว ต้องตรงกับ BE constants/school-year.js + api-pdf pdf/folio-gpax.js
export const CURRENT_YEAR_SCHOOL_TERM = '5';

// ปีของรอบ TCAS (cycle) = school_year + 1 → '2570' สำหรับ tcas70
// ใช้ประกอบ roundType/consent key: `${round}_${CURRENT_TCAS_YEAR}` เช่น '1_2570', 'offer_reply_2_2570'
export const CURRENT_TCAS_YEAR = `${Number(CURRENT_SCHOOL_YEAR) + 1}`;

// ป้ายรอบในข้อความ UI: 'TCAS70' และรอบปีก่อนหน้า 'TCAS69' (ข้อมูล last_year_* / ประวัติสมัครปีที่แล้ว)
export const CURRENT_TCAS_LABEL = `TCAS${Number(CURRENT_TCAS_YEAR) % 100}`;
export const PREV_TCAS_LABEL = `TCAS${(Number(CURRENT_TCAS_YEAR) % 100) - 1}`;
